import React, { useState, useEffect } from 'react';
import Pagination from '@material-ui/lab/Pagination';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import './css/gererAvis.css';
import { AfficheAvisResto, SuprimerAvisResto, AfficheAvisProduit, SuprimerAvisProduit } from '../../Api/SocieteApi/AvisApi';

const GererAvis = () => {

  const [loadAvisResto, setLoadAvisResto] = useState(false);
  const [dataAvisResto, setDataAvisResto] = useState([]);
  const [avisRestoExel, setAvisRestoExel] = useState([]);
  const [aviRestoPaginate, setAvisRestoPaginate] = useState([]);
  const [showPaginateAvisResto, setShowPaginateAvisResto] = useState(true);
  const [totalPageAvisResto, setTotalPageAvisResto] = useState();
  const [pageAvisResto, setPageAvisResto] = useState(1);


  const [loadAvisProduit, setLoadAvisProduit] = useState(false);
  const [dataAvisProduit, setDataAvisProduit] = useState([]);
  const [avisProduitExel, setAvisProduitExel] = useState([]);
  const [avisProduitPaginate, setAvisProduitPaginate] = useState([]);
  const [showPaginateAvisProduit, setShowPaginateAvisProduit] = useState(true);
  const [totalPageAvisProduit, setTotalPageAvisProduit] = useState();
  const [pageAvisProduit, setPageAvisProduit] = useState(1);

  let location = useLocation();

  useEffect(() => {
    AfficheAvisRestoData();
    if (dataAvisResto?.length < 10) {
      setShowPaginateAvisResto(false);
    } else {
      setShowPaginateAvisResto(true);
    }

    AfficheAvisProduitData();
    if (dataAvisProduit?.length < 10) {
      setShowPaginateAvisProduit(false);
    } else {
      setShowPaginateAvisProduit(true);
    }
  }, [dataAvisResto?.length, dataAvisProduit?.length]);



  const plural = (value) => {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }
  const viewDate = (date) => {
    return plural(new Date(date).getDate()) + "/" + plural(parseInt(new Date(date).getMonth() + 1)) + "/" + new Date(date).getFullYear();
  }


  const AfficheAvisRestoData = (value = null) => {
    let dataPage = value === null ? pageAvisResto : value;
    setLoadAvisResto(true);
    setAvisRestoExel([]);
    let dataAvis = [];
    AfficheAvisResto(dataPage).then(function (response) {
      console.log('Liste Client =>', response.data.donner);
      setDataAvisResto(response.data.clients);
      setAvisRestoPaginate(response.data.donner);
      setTotalPageAvisResto(response.data.totalPage);
      response.data.donner.forEach(element => {
        return dataAvis.push({ Id: element.id, Client: element.client.nom + " " + element.client.prenom, Critere: element.critere, Reponse: element.reponse, Date: viewDate(element.createdAt) })
      });

      setAvisRestoExel(dataAvis);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadAvisResto(false);
    });
  }




  const AfficheAvisProduitData = (value = null) => {
    let dataPage = value === null ? pageAvisProduit : value;
    setLoadAvisProduit(true);
    setAvisProduitExel([]);
    let dataAvis = [];
    AfficheAvisProduit(dataPage).then(function (response) {
      console.log('Liste Client =>', response.data.donner);
      setDataAvisProduit(response.data.clients);
      setAvisProduitPaginate(response.data.donner);
      setTotalPageAvisProduit(response.data.totalPage);
      response.data.donner.forEach(element => {
        return dataAvis.push({ Id: element.id, Client: element.client.nom + " " + element.client.prenom, Critere: element.critere, Reponse: element.reponse, Commentaire: element.commentaire, Date: viewDate(element.createdAt) })
      });

      setAvisProduitExel(dataAvis);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadAvisProduit(false);
    });
  }


  const handlePage = (event, value) => {
    setPageAvisResto(value);
    AfficheAvisRestoData(value);
  }


  const handlePageProduit = (event, value) => {
    setPageAvisProduit(value);
    AfficheAvisProduitData(value);
  }



  const handleDeleteAvis = (id) => {
    setLoadAvisResto(true);
    SuprimerAvisResto(id).then(function (response) {
      if (response.data.title === "success") {
        AfficheAvisRestoData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadAvisResto(false);
    });

  }



  const handleDeleteAvisProduit = (id) => {
    setLoadAvisProduit(true);
    SuprimerAvisProduit(id).then(function (response) {
      if (response.data.title === "success") {
        AfficheAvisProduitData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadAvisProduit(false);
    });

  }

  console.log('Avis resto exel =>', avisRestoExel);
  console.log('Avis produit exel =>', avisProduitExel);

  const handleExportExel = () => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(avisRestoExel);
    XLSX.utils.book_append_sheet(wb, ws, "Avis  restaurants");
    XLSX.writeFile(wb, "Avis restaurant.xlsx");
  }


  const handleExportExelProduit = () => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(avisProduitExel);
    XLSX.utils.book_append_sheet(wb, ws, "Avis produits");
    XLSX.writeFile(wb, "Avis produits.xlsx");
  }

  return (
    <div>
      <Helmet>
        <title>Gérer avis</title>
        <meta name='description' content='Gérer avis' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='container'>
        <div className='gererAvis'>
          <Tabs
            defaultActiveKey="avisResto"
            id="fill-tab-example"
            className="mb-3"
            justify
          >
            <Tab eventKey="avisResto" title="Avis sur le restaurant">
              <div className='header_gererAvis'>
                <div className='header_gererAvis'>
                  <div className='d-flex justify-content-end'>
                    <button className='btn btn_exporter' onClick={handleExportExel}>Exporter en exel</button>
                  </div>
                </div>
                {loadAvisResto === true ?
                  <div className="d-flex justify-content-center mt-2">
                    <Spinner animation="border" className="load" variant="info" size="md" />
                  </div> :
                  <div className='table-responsive'>
                    {aviRestoPaginate?.length !== 0 ?
                      <table className='table table-bordered'>
                        <thead>
                          <tr>
                            <th>Client</th>
                            <th>Critère</th>
                            <th>Réponse</th>
                            <th>Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {aviRestoPaginate.map((el, index) => {
                            return (
                              <tr key={index}>
                                <td>{el.client.nom} {el.client.prenom}</td>
                                <td>{el.critere}</td>
                                <td>{el.reponse}</td>
                                <td>{viewDate(el.createdAt)}</td>
                                <td> <span className=' fa fa-trash-o' onClick={() => handleDeleteAvis(el.id)}></span></td>
                              </tr>
                            )
                          })}

                        </tbody>
                      </table>
                      : <p>Avis sur le restaurant vide ...</p>}
                  </div>
                }

                {aviRestoPaginate.length !== 0 ?
                  showPaginateAvisResto && <div className='d-flex justify-content-center mt-4'>
                    <Pagination
                      shape="rounded"
                      count={Math.ceil(totalPageAvisResto)}
                      onChange={handlePage}
                    />
                  </div>
                  : ""}

              </div>
            </Tab>









            <Tab eventKey="avisProduit" title="Avis sur le Produit / service ">
              <div className='header_gererAvis'>
                <div className='d-flex justify-content-end'>
                  <button className='btn btn_exporter' onClick={handleExportExelProduit}>Exporter en exel</button>
                </div>
              </div>
              {loadAvisProduit === true ?
                <div className="d-flex justify-content-center mt-2">
                  <Spinner animation="border" className="load" variant="info" size="md" />
                </div> :
                <div className='table-responsive'>
                  {avisProduitPaginate.length !== 0 ?
                    <table className='table table-bordered'>
                      <thead>
                        <tr>
                          <th scope="col-2">Client</th>
                          <th scope="col-2">Critère</th>
                          <th scope="col-2">Réponse</th>
                          <th scope="col-2">Commentaire</th>
                          <th scope="col-2">Date</th>
                          <th scope="col-2">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {avisProduitPaginate.map((el, index) => {
                          return (
                            <tr key={index}>
                              <td>{el.client.nom} {el.client.prenom}</td>
                              <td>{el.critere}</td>
                              <td>{el.reponse}</td>
                              <td>{viewDate(el.createdAt)}</td>
                              <td>{el.commentaire}</td>
                              <td> <span className=' fa fa-trash-o' onClick={() => handleDeleteAvisProduit(el.id)}></span></td>
                            </tr>
                          )
                        })}

                      </tbody>
                    </table>
                    : <p>Avis sur le produit vide ...</p>}

                </div>
              }

              {avisProduitPaginate.length !== 0 ?
                showPaginateAvisProduit && <div className='d-flex justify-content-center mt-4'>
                  <Pagination
                    shape="rounded"
                    count={Math.ceil(totalPageAvisProduit)}
                    onChange={handlePageProduit}
                  />
                </div>
                : ""}
            </Tab>
          </Tabs>
          <p className="version">Version 1</p>
        </div>
      </div>
    </div>
  )
}

export default GererAvis